import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { IconButton as IconButton$2 } from '@chakra-ui/react';
import { Icon } from '../Icon/component.js';
import { withTooltip } from '../../hoc/with-tooltip.js';
var _excluded = ["icon", "ariaLabel", "isActive", "size"];
var IconButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var icon = props.icon,
      ariaLabel = props.ariaLabel,
      isActive = props.isActive,
      size = props.size,
      rest = _objectWithoutProperties(props, _excluded);
  /**
   * DOM
   */


  return /*#__PURE__*/React.createElement(IconButton$2, _extends({
    "data-object-type": "core-icon-button",
    ref: ref
  }, rest, {
    "aria-label": ariaLabel,
    icon: /*#__PURE__*/React.createElement(Icon, icon),
    px: 0,
    py: 0,
    isActive: !!isActive,
    size: size
  }));
});
IconButton.displayName = 'IconButton';
var IconButton$1 = withTooltip('IconButton')(IconButton);
export { IconButton, IconButton$1 as default };